export default __webpack_public_path__ + "static/media/vuesax-linear-profile-active.7ef962b3.svg";